export const config = {
  debugMode: false,

  // startScreenGame: 'dev',
  startScreenGame: 'tpgames/live-draw',
  lobbyGameId: 'tpgames/lobby-background',
} as const;
